module.exports = __webpack_public_path__ + "static/media/show_2.fbfaf774.png";